import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";
import useCookieConsent from "../hooks/useCookieConsent";

/** Fixed overlay, not in document flow — never shifts page layout while it appears/disappears. */
export default function CookieConsentBanner() {
  const { preferences, acceptAll, rejectNonEssential, openPreferences } = useCookieConsent();
  const reducedMotion = usePrefersReducedMotion();

  return (
    <AnimatePresence>
      {preferences === null && (
        <motion.div
          role="region"
          aria-label="Cookie consent"
          initial={reducedMotion ? false : { opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: reducedMotion ? 0 : 0.3 }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-ocean-900/10 bg-white/95 px-4 py-4 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] backdrop-blur-sm sm:px-6 dark:border-white/10 dark:bg-ocean-900/95"
        >
          <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 sm:flex-row sm:justify-between">
            <p className="text-center text-sm text-ocean-800/80 sm:text-left dark:text-foam-100/80">
              We use cookies to run this site and, with your consent, to understand how it&apos;s used. See our{" "}
              <Link to="/compliance#cookie-policy" className="font-semibold text-teal-600 hover:text-teal-700">
                Cookie Policy
              </Link>
              .
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-end sm:gap-3">
              <button
                type="button"
                onClick={openPreferences}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold text-ocean-800 ring-1 ring-ocean-900/15 hover:bg-ocean-900/5 dark:text-foam-100 dark:ring-white/15 dark:hover:bg-white/10"
              >
                Manage Preferences
              </button>
              <button
                type="button"
                onClick={rejectNonEssential}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold text-ocean-800 ring-1 ring-ocean-900/15 hover:bg-ocean-900/5 dark:text-foam-100 dark:ring-white/15 dark:hover:bg-white/10"
              >
                Reject Non-Essential
              </button>
              <button
                type="button"
                onClick={acceptAll}
                className="whitespace-nowrap rounded-full bg-teal-400 px-4 py-2 text-sm font-semibold text-ocean-950 hover:bg-teal-300"
              >
                Accept All
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
